export default {"src":"/_next/static/media/logo-gray.a506592c.svg","height":38,"width":134,"blurWidth":0,"blurHeight":0};